import React, { FC } from 'react';

import { useReactNativeProps } from '@eika-infrastruktur/mobilbank-lib';

import { Content } from '../../components/shared/Content';
import useTranslation, { format } from '../../hooks/useTranslation';
import UserProfile from '../UserProfile/UserProfile';
import About from './About/About';
import Adaptations from './Adaptations/Adaptations';
import MeMyselfAndI from './MeMyselfAndI/MeMyselfAndI';

import './Settings.scss';

const Settings: FC = () => {
    const translated = useTranslation();
    const { appVersion } = useReactNativeProps();

    return (
        <>
            <Content>
                <UserProfile />
                <MeMyselfAndI />
                <Adaptations />
                <About />
                {appVersion && (
                    <div className="about-app__app-version">
                        <span className="about-app__app-version-value">
                            {format(translated.aboutApp.version, appVersion)}
                        </span>
                    </div>
                )}
            </Content>
        </>
    );
};

export default Settings;
